import './_paymentMethod.scss'
import { useTranslation } from 'react-i18next'
import {
    type UseQueryResult,
    useMutation,
    useQuery,
    useQueryClient
} from 'react-query'

import {
    IconClockOutline,
    IconDollarCircleArrowsOutline,
    IconWalletOutline
} from 'assets/svg/sprite'
import { promiseToast } from 'components/Toast/Toast'
import InfoDiv from 'components/UI/InfoDiv/InfoDiv'
import { ActionCard } from 'components-ref/molecules/ActionCard/ActionCard'
import { Icons } from 'helpers/icons'
import {
    deleteBankInformation,
    getBankInformation
} from 'services/endpoints/settings/general/payout'

export const Ach = () => {
    const { t } = useTranslation()
    const queryClient = useQueryClient()

    const { data, isLoading }: UseQueryResult<Record<string, any>> = useQuery(
        'bankInfortmation',
        getBankInformation,
        {
            select(data) {
                return data
            },
            refetchOnWindowFocus: false
        }
    )

    const deleteAccountInfo = useMutation(deleteBankInformation, {
        onSettled: async () => {
            await queryClient.invalidateQueries('bankInfortmation')
        }
    })

    return (
        <>
            {data?.beneficiaryAccount ? (
                <ActionCard
                    disabled={isLoading}
                    icon={Icons.payments}
                    iconSize='big'
                    text={`${data.beneficiary_first_name} ${data.beneficiary_last_name}`}
                    subtext={
                        <div>
                            <div>
                                <span>
                                    {`${t('account')} # `}
                                    <span className='paymentMethod__actionCard__account'>{`****${data?.beneficiaryAccount?.slice(
                                        -4
                                    )}`}</span>
                                </span>
                            </div>
                            <div>{`${data.beneficiaryBankName}, ${data.beneficiaryBankCity}`}</div>
                        </div>
                    }
                    hasArrow={true}
                    link='/settings/general/payout-settings/payment-method/ach/bank-information'
                    trashFn={() => {
                        promiseToast(deleteAccountInfo.mutateAsync(), {
                            loading: t('sending'),
                            error: t('error:anErrorOccuredPleaseTryAgain'),
                            success: t('successfullyDeleted')
                        })
                    }}
                />
            ) : (
                <ActionCard
                    disabled={isLoading}
                    link='/settings/general/payout-settings/payment-method/ach/bank-information'
                    icon={Icons.payment_plus}
                    iconSize='big'
                    text={t('addBankAccount')}
                    addNewText
                />
            )}
            <div className='paymentMethod__info'>
                <InfoDiv
                    icon={<IconWalletOutline width='24' height='24' />}
                    title={t('settings:MinimumWithdrawal')}
                    boldText={'$20.00'}
                />
                <InfoDiv
                    icon={<IconClockOutline />}
                    title={t('settings:ProcessingTime')}
                    boldText={'3-5'}
                    plainText={t('settings:BuisnessDays')}
                />
                <InfoDiv
                    icon={
                        <IconDollarCircleArrowsOutline
                            color='black'
                            width='26'
                            height='26'
                        />
                    }
                    title={t('settings:OtherFeatures')}
                    boldText={t('settings:NoLimits')}
                    plainText={t('settings:onDailyWithdrawals')}
                />
            </div>
        </>
    )
}
